module.exports = __webpack_public_path__ + "img/010.f662e7cc.png";